var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03089 12.1887C9.84127 13.8454 11.1842 15.1823 12.8447 15.9851C12.9662 16.0427 13.1006 16.0677 13.2346 16.0575C13.3687 16.0474 13.4978 16.0025 13.6092 15.9273L16.0541 14.297C16.1622 14.2249 16.2866 14.1809 16.4161 14.169C16.5455 14.1571 16.6758 14.1777 16.7953 14.2289L21.3692 16.1892C21.5246 16.2552 21.6543 16.3699 21.7388 16.516C21.8233 16.6622 21.8581 16.8318 21.8378 16.9994C21.6932 18.1306 21.1413 19.1704 20.2853 19.924C19.4293 20.6776 18.328 21.0934 17.1875 21.0934C13.6651 21.0934 10.287 19.6942 7.79624 17.2034C5.30552 14.7127 3.90625 11.3346 3.90625 7.81218C3.90631 6.67173 4.32206 5.5704 5.07567 4.71441C5.82927 3.85841 6.86904 3.30646 8.00029 3.16189C8.16788 3.14161 8.33753 3.17634 8.48366 3.26086C8.6298 3.34537 8.74451 3.47509 8.81052 3.63047L10.7725 8.20838C10.8232 8.3268 10.8439 8.45592 10.8327 8.58426C10.8214 8.71259 10.7786 8.83616 10.7081 8.94396L9.08345 11.4264C9.0095 11.538 8.96579 11.667 8.95658 11.8006C8.94736 11.9342 8.97297 12.0679 9.03089 12.1887V12.1887Z",
    stroke: "#4F7D9C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.6bacfcefe66c16c962861fe28bcd4cf9.svg";
export { ForwardRef as ReactComponent };